require('./impositionInterestRenewalStep1.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { FormattedText } = require('core/i18n').i18n;
// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
// @helpers
const { getFullName } = require('utilities/personalDataHelper');

class ImpositionInterestRenewalStep1 extends React.Component {
    render() {
        const {
            immProfile,
            immDeposits,
            depositId,
            impositionId,
            isRenewal
        } = this.props;

        const immDeposit = immDeposits.getIn(['byId', depositId]);

        let content;

        const promptTextKey = isRenewal ? 'impositionInterestRenewal-step1SetRenewalPrompt' : 'impositionInterestRenewal-step1Prompt';

        const clientFullName = getFullName(immProfile);

        const injectedStrings = [
            clientFullName,
            impositionId,
            immDeposit.getIn([ 'contract', 'fullContractNumber' ]).trim(),
            clientFullName
        ];


        content = (
            <div className="imposition-interest-renewal-step1">
                <h4 className="wizard-step--vertical__title">
                    <FormattedText value="impositionInterestRenewal-step1Title" />
                </h4>

                <BlockInfo extraClass="imposition-interest-renewal-step1__prompt">
                    <p className="imposition-interest-renewal-step1__disclaimer-text">
                        <FormattedText
                            value={promptTextKey}
                            injectedStrings={injectedStrings}
                        />
                    </p>
                </BlockInfo>
            </div>
        );

        return content;
    }
}

ImpositionInterestRenewalStep1.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    depositId: PropTypes.string.isRequired,
    impositionId: PropTypes.string.isRequired,
    isRenewal: PropTypes.bool.isRequired,
};

module.exports = ImpositionInterestRenewalStep1;
